/**
 * MechaGuard - Toast (浮动提示)
 *
 * 用于「金币不足」「第 N 波来袭」「漏怪」等即时反馈。
 * 同时最多显示 maxVisible 条，超出的直接丢弃最旧的一条。
 */

export class Toast {
  /**
   * @param {number} [maxVisible=3]
   * @param {number} [duration=1700] 默认停留毫秒数
   */
  constructor(maxVisible = 3, duration = 1700) {
    this.maxVisible = maxVisible;
    this.duration = duration;
    this._root = null;
  }

  init() {
    this._root = document.getElementById('toast-container');
  }

  /**
   * @param {string} message
   * @param {{duration?:number, variant?:'danger'|'gold'|''}} [opts]
   */
  show(message, opts = {}) {
    if (!this._root || !message) return;

    const duration = opts.duration ?? this.duration;
    const variant = opts.variant ?? '';

    // 超出上限时丢弃最旧的
    while (this._root.children.length >= this.maxVisible) {
      this._root.removeChild(this._root.firstChild);
    }

    const el = document.createElement('div');
    el.className = variant ? `toast toast--${variant}` : 'toast';
    el.textContent = message;
    this._root.appendChild(el);

    window.setTimeout(() => {
      el.classList.add('is-out');
      window.setTimeout(() => el.remove(), 320);
    }, duration);
  }

  /** 清空所有提示 */
  clear() {
    if (this._root) this._root.innerHTML = '';
  }
}
